export const MAX_GUESSES = 10;
